const PENDING_COMMERCE_ORDER_KEY = 'intellerview.pendingCommerceOrderId';

export const rememberPendingCommerceOrder = (orderId: string) => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(PENDING_COMMERCE_ORDER_KEY, orderId);
  window.localStorage.setItem(PENDING_COMMERCE_ORDER_KEY, orderId);
};

export const getRememberedPendingCommerceOrder = (): string | null => {
  if (typeof window === 'undefined') return null;
  const value =
    window.sessionStorage.getItem(PENDING_COMMERCE_ORDER_KEY) ||
    window.localStorage.getItem(PENDING_COMMERCE_ORDER_KEY);
  return value && value.trim().length > 0 ? value : null;
};

export const clearRememberedPendingCommerceOrder = (orderId?: string | null) => {
  if (typeof window === 'undefined') return;
  if (!orderId) {
    window.sessionStorage.removeItem(PENDING_COMMERCE_ORDER_KEY);
    window.localStorage.removeItem(PENDING_COMMERCE_ORDER_KEY);
    return;
  }

  const current =
    window.sessionStorage.getItem(PENDING_COMMERCE_ORDER_KEY) ||
    window.localStorage.getItem(PENDING_COMMERCE_ORDER_KEY);
  if (current === orderId) {
    window.sessionStorage.removeItem(PENDING_COMMERCE_ORDER_KEY);
    window.localStorage.removeItem(PENDING_COMMERCE_ORDER_KEY);
  }
};

export const submitPayFastHostedPayment = (payfastUrl: string, formFields: Record<string, string>) => {
  if (typeof document === 'undefined') {
    throw new Error('PayFast redirect is only available in the browser.');
  }

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = payfastUrl;
  form.style.display = 'none';

  Object.entries(formFields).forEach(([key, value]) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
